import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ExportFileList, DeleteExportFileData } from '@/api/sys.user';
import util from '@/libs/util';
export default {
  created: function created() {
    this._ExportFileList();
  },
  data: function data() {
    return {
      userName: util.getUserInfo().USER_NAME,
      loading: false,
      mainTable: [],
      pageInfo: {
        TotalCount: 1,
        PageSize: 15,
        PageIndex: 1
      },
      key: null
    };
  },
  methods: {
    // 点击下载
    handleFileName: function handleFileName(item) {
      console.log(item);

      if (item.Status === 1) {
        window.open(this.$store.getters.getVUE_APP_DOWN + item.FileUrl);
      } else if (item.Status === 2) {
        this.$message.warning('数据为空');
      } else {
        this.$message.warning('数据处理中');
      }
    },
    // 复选选择
    checkboxChange: function checkboxChange(_ref) {
      var checked = _ref.checked,
          row = _ref.row;
      console.log(checked);
      console.log(row);
    },
    // 删除
    handleDelete: function handleDelete() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var selectRecords, FileUrlList, params, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                selectRecords = _this.$refs.xTable.getCheckboxRecords();
                console.log('selectRecords', selectRecords);
                FileUrlList = selectRecords.map(function (v) {
                  var url = v.FileUrl;
                  return url;
                });

                if (!(selectRecords.length === 0)) {
                  _context.next = 6;
                  break;
                }

                _this.$message.warning('请至少选择一条');

                return _context.abrupt("return");

              case 6:
                params = {
                  UserName: _this.userName,
                  FileUrlList: FileUrlList
                };
                console.log('params', params);
                _context.next = 10;
                return DeleteExportFileData(params);

              case 10:
                res = _context.sent;
                console.log(res);

                if (res.code === 0) {
                  _this.$message.success('记录删除成功');

                  _this._ExportFileList();
                }

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 搜索
    handleSearch: function handleSearch() {
      this._ExportFileList();
    },
    handleSizeChange: function handleSizeChange(size) {
      this.pageInfo.PageSize = size;

      this._ExportFileList();
    },
    handleCurrentChange: function handleCurrentChange(index) {
      this.pageInfo.PageIndex = index;

      this._ExportFileList();
    },
    switchStatus: function switchStatus(Items) {
      switch (Items.Status) {
        case 0:
          Items.statusName = '处理中';
          Items.statusStyle = 'color:#e6a23c';
          return;

        case 1:
          Items.statusName = '已完成';
          Items.statusStyle = 'color:#00bb7c';
          return;

        case 2:
          Items.statusName = '数据空';
          Items.statusStyle = 'color:#f78989';
      }
    },
    _ExportFileList: function _ExportFileList() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.loading = true;
                params = {
                  'Data.User_Name': _this2.userName,
                  Limit: _this2.pageInfo.PageSize,
                  Page: _this2.pageInfo.PageIndex,
                  Key: _this2.key
                };
                _context2.next = 4;
                return ExportFileList(params);

              case 4:
                res = _context2.sent;
                _this2.loading = false;
                console.log('数据导出list', res);

                if (res.code === 0) {
                  _this2.mainTable = res.data.Items.map(function (v) {
                    v.statusName = '获取中...';
                    v.statusStyle = null;

                    _this2.switchStatus(v);

                    return v;
                  });
                  _this2.pageInfo.TotalCount = res.data.TotalCount;
                } else {
                  _this2.$message.warning('获取下载列表失败');
                }

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};